import { atom } from "recoil";

const recordLoading = atom({
    key: 'record-loading',
    default: true
});

const recordCurrentPage = atom({
    key: 'record-current-page',
    default: 1,
});

const recordSearch = atom({
    key: 'record-search',
    default: ''
});

const recordData = atom({
    key: 'record-data',
    default: {},
});

export {
    recordLoading, 
    recordCurrentPage, 
    recordSearch, 
    recordData
};